import { actions as teamDataActions } from 'store/actions/teamData';
import u from 'updeep';

const initialState = {
    selectedTeamId: '',
    teamId: '',
    displayName: '',
    users: [],
    isLoading: false,
    loadingUserId: null,
    statistics: null,
};

const teamDataReducer = (state = initialState, action) => {
    switch(action.type) {
        case teamDataActions.GET_TEAM_DATA:
            return u({
                users: action.payload.users,
                teamId: action.payload.team_id,
                allowedDomains: action.payload.allowed_domains,
                displayName: action.payload.display_name,
            }, state);
        case teamDataActions.SET_SELECTED_TEAM:
            return u({ selectedTeamId: action.payload }, state);
        case teamDataActions.SET_IS_LOADING:
            return u({ isLoading: action.payload }, state);
        case teamDataActions.SET_USER_IS_LOADING:
            return u({ loadingUserId: action.payload }, state);
        case teamDataActions.UPDATE_TEAM_USER:
            // eslint-disable-next-line
            const updatedUsers = state.users.map(user => {
                const foundUser = action.payload.users.find(pu => pu.user_id === user.userId);
                if (!foundUser) return;
                return { ...user, role: foundUser.role };
            }).filter(x => x);
            return u({ users: updatedUsers }, state);
        case teamDataActions.DELETE_TEAM_USER:
            // eslint-disable-next-line
            const filteredUsers = state.users.map(user => {
                const foundUser = action.payload.users.find(pu => pu.userId === user.userId);
                if (!foundUser) return;
                return user;
            }).filter(x => x);
            return u({ users: filteredUsers }, state);
        case teamDataActions.GET_TEAM_STATISTICS:
            return u({ statistics: action.payload, teamId: action.payload.teamId }, state);

        default:
            return state;
    }
};

export { teamDataReducer };

